export default {
      id: "apply-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#apply-usage",
      toString: function () {
        return this.url;
      }
    }